/*
  Barklie "What's inside?"-carrousel op de productpagina (S7, 13 okt 2026), gedrag zoals de referentie-PDP's
  (`.wf-ingredient-carousel`, gemeten 13 okt):
  - vanaf 768px: klassen --centre / --prev / --next / --off (+ data-side) wisselen; CSS doet de overgang (.2s);
    rondlopend; pijlen, slepen met muis/pen (≥ 48px), pijltjestoetsen; zijkaarten zijn niet klikbaar.
  - onder 768px: gewone horizontale scroll met snap; pijlen scrollen één kaart (rondlopend, zacht), de kaart in het
    midden wordt na het scrollen de actieve kaart.
  - wisselen draait een omgeklapte kaart terug; stippen: max. 5, venster met kleinere randstippen bij > 5 kaarten.
  - flip-kaart: data-flipped, aria-expanded, voorkant/achterkant inert, focus naar de knop op de andere kant.
  - het uitklapblok "See all ingredients" (aria-expanded, grid-rows 0fr → 1fr in CSS).
*/
(function () {
  var mqDesk = window.matchMedia('(min-width: 768px)');
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initCarousel(car) {
    if (car.__bkPin) return;
    car.__bkPin = true;
    var slides = Array.prototype.slice.call(car.querySelectorAll('[data-bk-pin-slide]'));
    var n = slides.length;
    var track = car.querySelector('[data-bk-pin-track]');
    var stage = car.querySelector('.bk-pin-car__stage');
    var dotsBox = car.querySelector('[data-bk-pin-dots]');
    var dots = dotsBox ? Array.prototype.slice.call(dotsBox.querySelectorAll('span')) : [];
    var index = parseInt(car.getAttribute('data-index'), 10) || 0;
    var POS = ['centre', 'prev', 'next', 'off'];

    function unflipAll(except) {
      slides.forEach(function (s) {
        var card = s.querySelector('.bk-pic');
        if (card && card !== except && card.getAttribute('data-flipped') === 'true') setFlip(card, false, false);
      });
    }

    function render() {
      var desk = mqDesk.matches;
      slides.forEach(function (s, i) {
        var d = ((i - index) % n + n) % n;
        var pos = d === 0 ? 'centre' : d === 1 ? 'next' : d === n - 1 ? 'prev' : 'off';
        POS.forEach(function (p) { s.classList.toggle('bk-pin-car__slide--' + p, p === pos); });
        if (pos === 'off') s.setAttribute('data-side', d < n / 2 ? 'next' : 'prev');
        else s.removeAttribute('data-side');
        /* referentie: alleen de middelste kaart is bedienbaar (desktop); mobiel kan elke kaart in beeld staan */
        if (desk && d !== 0) s.setAttribute('inert', ''); else s.removeAttribute('inert');
      });
      if (dotsBox) {
        dotsBox.setAttribute('aria-label', 'Page ' + (index + 1) + ' of ' + n);
        var start = 0, sizes = [8, 8, 8, 8, 8];
        if (n > 5) {
          start = Math.min(Math.max(index - 2, 0), n - 5);
          sizes = start === 0 ? [8, 8, 8, 6, 4] : start === n - 5 ? [4, 6, 8, 8, 8] : [6, 8, 8, 8, 6];
        }
        dots.forEach(function (dot, k) {
          dot.style.width = dot.style.height = sizes[k] + 'px';
          dot.classList.toggle('is-active', k === index - start);
        });
      }
    }

    function go(to, fromScroll) {
      var next = ((to % n) + n) % n;
      if (next !== index) unflipAll(null);
      index = next;
      render();
      if (!mqDesk.matches && !fromScroll) scrollToIndex(index, true);
    }

    function scrollToIndex(i, smooth) {
      var s = slides[i];
      if (!s || !track) return;
      var left = s.offsetLeft - track.offsetLeft - (track.clientWidth - s.offsetWidth) / 2;
      track.scrollTo({ left: left, behavior: smooth && !mqReduce.matches ? 'smooth' : 'auto' });
    }

    var prev = car.querySelector('[data-bk-pin-prev]');
    var nextBtn = car.querySelector('[data-bk-pin-next]');
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(index + 1); });

    car.addEventListener('keydown', function (e) {
      if (n < 2 || e.target.closest('input, textarea')) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
    });

    /* slepen (desktop); op mobiel scrolt de track zelf */
    var startX = null, startY = 0;
    if (stage && n > 1) {
      stage.addEventListener('pointerdown', function (e) {
        if (!mqDesk.matches || e.button > 0) return;
        startX = e.clientX; startY = e.clientY;
      });
      window.addEventListener('pointerup', function (e) {
        if (startX === null) return;
        var dx = e.clientX - startX, dy = e.clientY - startY;
        startX = null;
        if (Math.abs(dx) >= 48 && Math.abs(dx) > Math.abs(dy)) go(index + (dx < 0 ? 1 : -1));
      });
      window.addEventListener('pointercancel', function () { startX = null; });
      stage.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }

    /* mobiel: na het scrollen wordt de kaart in het midden actief */
    var scrollTimer = null;
    if (track) {
      track.addEventListener('scroll', function () {
        if (mqDesk.matches) return;
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var mid = track.scrollLeft + track.clientWidth / 2;
          var best = index, bestD = Infinity;
          slides.forEach(function (s, i) {
            var c = s.offsetLeft - track.offsetLeft + s.offsetWidth / 2;
            var d = Math.abs(c - mid);
            if (d < bestD) { bestD = d; best = i; }
          });
          if (best !== index) go(best, true);
        }, 80);
      }, { passive: true });
    }

    function onMq() {
      render();
      /* na de wissel naar mobiel eerst de nieuwe opmaak (scroll-track) laten toepassen */
      if (!mqDesk.matches) setTimeout(function () { scrollToIndex(index, false); }, 50);
    }
    if (mqDesk.addEventListener) mqDesk.addEventListener('change', onMq); else mqDesk.addListener(onMq);

    render();
    if (!mqDesk.matches) scrollToIndex(index, false);
  }

  /* flip-kaart */
  function setFlip(card, back, moveFocus) {
    card.setAttribute('data-flipped', back ? 'true' : 'false');
    var front = card.querySelector('[data-bk-pic-front]');
    var rear = card.querySelector('[data-bk-pic-back]');
    if (back) { front.setAttribute('inert', ''); rear.removeAttribute('inert'); }
    else { rear.setAttribute('inert', ''); front.removeAttribute('inert'); }
    card.querySelectorAll('[data-bk-pic-flip]').forEach(function (b) { b.setAttribute('aria-expanded', back ? 'true' : 'false'); });
    if (moveFocus) {
      var target = (back ? rear : front).querySelector('[data-bk-pic-flip]');
      if (target) target.focus({ preventScroll: true });
    }
  }

  document.addEventListener('click', function (e) {
    var flip = e.target.closest('[data-bk-pic-flip]');
    if (flip) {
      var card = flip.closest('.bk-pic');
      setFlip(card, card.getAttribute('data-flipped') !== 'true', true);
      return;
    }
    var acc = e.target.closest('[data-bk-pin-acc]');
    if (acc) {
      var open = acc.getAttribute('aria-expanded') !== 'true';
      acc.setAttribute('aria-expanded', open ? 'true' : 'false');
      acc.closest('.bk-pin__acc').toggleAttribute('data-open', open);
    }
  });

  function initAll() { document.querySelectorAll('[data-bk-pin-car]').forEach(initCarousel); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
